<template>
    <div class="menu-config-container">
        <div class="selected-component-options">
            <span v-if="elementoSelecionado?.componenteId === 'botaoLimpar-proxy'" class="font-medium">Editar Botão Limpar Campos</span>
            <span v-else class="font-medium">Editar {{ tabelaDePesquisaComponente[elementoSelecionado?.componente]?.titulo }}</span>
            <component
                class="config-componente"
                v-for="(campo, index) in obterCampos(elementoSelecionado?.componente)"
                :key="index"
                :is="campo.componente"
                v-bind="campo.componenteProps"
                :modelValue="valoresCampos[campo.componenteProps.label]"
                @update:modelValue="lidarComMudanca(campo, $event)"
            >
            </component>
        </div>
    </div>
</template>

<script setup>
import { useConfigComponenteEditor } from '@/composables/useConfigComponenteEditor';
import { LAYOUTS_DISPONIVEIS, COMPONENTES_DISPONIVEIS, CAMPOS_DISPONIVEIS, OUTROS_CAMPOS } from '@/constants/componentesCatalogo';
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';

const tabelaDePesquisaComponente = [...COMPONENTES_DISPONIVEIS, ...LAYOUTS_DISPONIVEIS, ...CAMPOS_DISPONIVEIS, ...OUTROS_CAMPOS].reduce(
    (acumulador, componente) => {
        acumulador[componente.componente] = {
            componente: componente.elemento,
            titulo: componente.titulo,
        };
        return acumulador;
    },
    {}
);

const { obterCampos } = useConfigComponenteEditor();
const store = useStore();
const elementoSelecionado = computed(() => store.getters['landingPage/obterElementoSelecionado']);
const valoresCampos = ref({});

watch(
    elementoSelecionado,
    (novoValor) => {
        if (novoValor) {
            const campos = obterCampos(novoValor.componente);
            const novosValores = {};
            campos.forEach((campo) => {
                novosValores[campo.componenteProps.label] = campo.obterValorAtual(novoValor);
            });
            valoresCampos.value = novosValores;
        }
    },
    { immediate: true, deep: true }
);

const lidarComMudanca = (campo, novoValor) => {
    valoresCampos.value[campo.componenteProps.label] = novoValor;
    campo.lidarComMudanca(novoValor, elementoSelecionado.value.componenteId);
};
</script>

<style scoped lang="scss">
.menu-config-container {
    .selected-component-options {
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        background-color: white;
        gap: 8px;
        padding: 8px;
    }
}
</style>
